<template>
  <van-dialog
    v-model="isShowItms"
    :showConfirmButton="false"
    :showCancelButton="false"
    className="dialog-box"
  >
    <template #title>
      <div class="header">
        <div class="title-box">
          <div class="title">
            <div class="title-bag">
              <div class="text">{{ title }}</div>
              <div class="backcloth">
                <img src="@/assets/mybox/home/backcloth.png" />
              </div>
            </div>
          </div>
          <div class="hide" @click="hide">
            <img src="@/assets/mybox/home/hide.png" />
          </div>
        </div>
      </div>
    </template>
    <div class="content">
      <div class="main">
        <slot ></slot>
      </div>
    </div>
  </van-dialog>
</template>
<script>
export default {
  
  props: {
    isShow: {
      type: Boolean,
    },
    title: {
      type: String,
      default: "Rules",
    },
  },
  data() {
    return {
      isShowItms: this.isShow,
    };
  },
  watch: {
    isShow() {
      this.isShowItms = this.isShow;
    },
    closeModal() {
      this.isShowItms = false;
    },
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-box {
  width: 90%;
}
.header {
  font-size: 0.44rem;
  background: url("@/assets/mybox/home/Colorgradient.png") no-repeat;
  background-size: 100% 100%;
  height: 2rem;
  .title-box {
    height: 1.2rem;
    padding: 0.2rem;
    position: relative;

    .title {
      padding-top: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .title-bag {
        width: fit-content;
        position: relative;
        .text {
          transform: translateY(10px);
        }
        .backcloth {
          width: 100%;
          height: 0.26rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .hide {
      position: absolute;
      top: 0.2rem;
      right: 0.2rem;
    }
  }
}
::v-deep .van-dialog__header {
  padding-top: 0;
}

.content {
  width: 100%;
  height: 100%;
  background: white;
  padding: 0.3rem;
  padding-top: 0;
}
.main {
  min-height: 3rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f8f8;
  border-radius: 18px;
}
</style>
